export const APARTMENT_FORM_TYPE = {
  BUY: 'buy',
  SELL: 'sell',
  HERITAGE: 'heritage',
};
